export default "__VITE_ASSET__CFAN3Qwe__"